import React from 'react';
import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Card from 'components/card/Card';
import { getDefaultRoute } from 'utils/roleAccess';
import { useAuth } from 'contexts/AuthContext';

export default function UnauthorizedView() {
  const navigate = useNavigate();
  const { roles, accesses } = useAuth();

  return (
    <Box maxW="520px" mx="auto" mt={10}>
      <Card p={8} textAlign="center">
        <Heading size="md" mb={3}>Acceso no autorizado</Heading>
        <Text color="gray.600" mb={6}>
          No tenés permisos para ver esta sección. Si creés que es un error, contactá al administrador.
        </Text>
        <Button
          colorScheme="brand"
          onClick={() => navigate(getDefaultRoute(roles, accesses))}
        >
          Ir a mi inicio
        </Button>
      </Card>
    </Box>
  );
}
